export default __webpack_public_path__ + "static/media/slide4.4dea0cdf.webp";